import { GrupoModel, GRUPO_DEFAULT } from "./GrupoModel";
import { PaginationModel } from '@/models/commons/PaginationModel';

export interface FiltroCadastroUsuarioModel {
  nome: string;
  email: string;
  grupo: GrupoModel;
  options: PaginationModel;
}

export const FILTRO_DEFAULT = () => {
  return {
    nome: "",
    email: "",
    grupo: GRUPO_DEFAULT(),
    options: {
      page: 1,
      itemsPerPage: 5,
      itemsLength: 0
    }
  };
};
